import type { CSSProperties } from "react";
import type { Scenario } from "@/domain/entities";

/** FNV-1a over the English name, so the hue is stable across UI languages. */
export function scenarioHue(scenario: Pick<Scenario, "name">): number {
  let hash = 0x811c9dc5;
  for (const ch of scenario.name.en) {
    hash ^= ch.codePointAt(0) ?? 0;
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash % 360;
}

/**
 * Pastel background for a scenario's name in the Settings add-scenario block.
 * Lightness and chroma come from theme tokens (see theme.css), so light and
 * dark themes keep the label contrast while only the hue varies per scenario.
 */
export function scenarioTintStyle(scenario: Pick<Scenario, "name">): CSSProperties {
  return { background: `oklch(var(--card-tint-l) var(--card-tint-c) ${scenarioHue(scenario)})` };
}
